import { AWSCloudAccount } from './AWS/AWSCloudAccount';
import { AzureCloudAccount } from './Azure/AzureCloudAccount';
import { GCPCloudAccount } from './GCP/GCPCloudAccount';
import { DownloadableCloudAccount } from './Downloadable/DownloadableCloudAccount';

export const CLOUD_TYPE_COMPONENTS = {
    aws: AWSCloudAccount,
    azure: AzureCloudAccount,
    azure_local: AzureCloudAccount,
    gcp: GCPCloudAccount,
    rivermeadow_standalone: DownloadableCloudAccount,
    openshift: DownloadableCloudAccount,
    openstack: DownloadableCloudAccount,
    nc2: DownloadableCloudAccount,
    hpe_vme: DownloadableCloudAccount,
    hyperv: DownloadableCloudAccount,
};

export const getCloudComponent = (cloudType) => {
    return CLOUD_TYPE_COMPONENTS[cloudType] || null;
};
